import { createAction } from "@reduxjs/toolkit";
import { AUTH_ACTIONS, AUTH_ENDPOINT_NAMES } from "../types";

export const resetError = createAction(
  AUTH_ACTIONS.RESET_ERROR_AUTH,
  (endpoint: AUTH_ENDPOINT_NAMES) => ({ payload: { endpoint } })
);
